export enum EncounterType {
  ALLTYPES = "All",
  ALL = "All (Inpatient/Outpatient/Professional)",
  INPATIENT = "Inpatient",
  OUTPATIENT = "Outpatient",
  PROFESSIONAL = "Professional",
  SHARED = "Shared (Inpatient/Outpatient)",
}

export enum PatientEncounterType {
  IP = "IP", // 'Inpatient',
  OP = "OP", // 'Outpatient',
  ER = "ER", // 'Emergency Room',
  SDS = "SDS", // 'Same Day Surgery'
  PRO = "PRO", // 'Professional'
}
